import { ServiceType } from '@wix/bookings-uou-types';
export class DurationMapper {
    constructor(regionalSettingsLocale, options, formatter) {
        this.regionalSettingsLocale = regionalSettingsLocale;
        this.options = options;
        this.formatter = formatter;
        this.isDateInCurrentYear = (date) => {
            const now = new Date();
            return now.getFullYear() === date.getFullYear();
        };
        this.isDateInThePast = (date) => {
            const now = new Date();
            return date.getTime() < now.getTime();
        };
    }
    courseText({ startDateAsUTC, viewTimezone, isPassedEndDate, }) {
        if (isPassedEndDate) {
            return this.formatter(this.options.courseEndedText);
        }
        if (startDateAsUTC) {
            const startDate = new Date(startDateAsUTC);
            const dateFormat = this.isDateInCurrentYear(startDate)
                ? {
                    month: 'short',
                    day: 'numeric',
                    timeZone: viewTimezone,
                }
                : {
                    year: 'numeric',
                    month: 'short',
                    day: 'numeric',
                    timeZone: viewTimezone,
                };
            const formattedDate = new Intl.DateTimeFormat(this.regionalSettingsLocale, dateFormat).format(startDate);
            return this.isDateInThePast(startDate)
                ? this.formatter(this.options.coursePassedText, {
                    date: formattedDate,
                    interpolation: { escapeValue: false },
                })
                : this.formatter(this.options.courseInFutureText, {
                    date: formattedDate,
                    interpolation: { escapeValue: false },
                });
        }
        return '';
    }
    formatDurationFromMinutes({ durationInMinutes, hourUnit, minuteUnit, }) {
        const hours = Math.floor(durationInMinutes / 60);
        const minutes = durationInMinutes % 60;
        const hourText = this.formattedHours(hours, hourUnit);
        const minuteText = this.formatter(minuteUnit, { minutes });
        return hours ? hourText + (minutes ? ` ${minuteText}` : '') : minuteText;
    }
    formattedHours(hours, hourUnit) {
        const hourText = this.formatter(hourUnit, { hours });
        const hoursAriaLabelFormatterKey = 'duration.units.aria-hours';
        const isHourTextForAriaLabel = hourUnit === hoursAriaLabelFormatterKey;
        return hours === 1 && isHourTextForAriaLabel
            ? hourText.slice(0, -1)
            : hourText;
    }
    durationTextFromMinutes(durationInMinutes) {
        const hourUnit = this.options.hourUnit;
        const minuteUnit = this.options.minuteUnit;
        return this.formatDurationFromMinutes({
            durationInMinutes,
            hourUnit,
            minuteUnit,
        });
    }
    durationAriaLabelFromMinutes(durationInMinutes) {
        const hourUnit = this.options.hourAriaUnit;
        const minuteUnit = this.options.minuteAriaUnit;
        return this.formatDurationFromMinutes({
            durationInMinutes,
            hourUnit,
            minuteUnit,
        });
    }
    durationText({ serviceType, isDurationVaries, durationInMinutes, startDateAsUTC, durationAria, viewTimezone, isPassedEndDate, }) {
        if (serviceType === ServiceType.COURSE) {
            return this.courseText({
                startDateAsUTC,
                viewTimezone,
                isPassedEndDate,
            });
        }
        if (isDurationVaries) {
            return this.formatter(this.options.durationVaries);
        }
        if (durationInMinutes) {
            if (durationAria) {
                return this.durationAriaLabelFromMinutes(durationInMinutes);
            }
            return this.durationTextFromMinutes(durationInMinutes);
        }
        return '';
    }
}
//# sourceMappingURL=duration.mapper.js.map